<template>
  <ConfigProvider
    :prefixCls="appStore.prefixCls"
    :locale="getAntdLocale"
    :theme="{
      token: {
        colorPrimary: appStore.themeColor,
      },
      algorithm:
        appStore.darkMode === ThemeEnum.DARK ? theme.darkAlgorithm : theme.defaultAlgorithm,
    }"
  >
    <AppProvider style="position: relative">
      <RouterView />
      <MessageCard />
    </AppProvider>
  </ConfigProvider>
</template>

<script lang="ts" setup>
  import theme from 'ant-design-vue/es/theme';
  import { ConfigProvider } from 'ant-design-vue';
  import { onUnmounted } from 'vue';
  import { AppProvider } from '/@/components/Application';
  import { useTitle } from '/@/hooks/web/useTitle';
  import { useLocale } from '/@/locales/useLocale';
  import { usePermissionStoreWithOut } from '/@/store/modules/permission';
  import { useProjectStoreWithOut } from '/@/store/modules/project';
  import { MessageCard } from './views/modules/shanshe/components/message_card/index';
  import { useAppStore } from '/@/store/modules/app';
  import { ThemeEnum } from '/@/enums/appEnum';
  import { prefixCls } from '/@/settings/designSetting';
  import { startAppTabTaskBadge } from '/@/utils/tab_task_badge/tab_task_badge';
  import '/@/standard_branch';

  // support Multi-language
  const { getAntdLocale } = useLocale();
  const appStore = useAppStore();
  const permissionStore = usePermissionStoreWithOut();
  const projectStore = useProjectStoreWithOut();
  document.documentElement.style.setProperty('--primary-color', appStore.themeColor); // 动态修改颜色
  if (
    permissionStore.getBusinessPermission.length === 0 &&
    window.sessionStorage.businessPermission
  ) {
    permissionStore.setBusinessPermission(JSON.parse(window.sessionStorage.businessPermission));
  }
  if (!projectStore.isNew && window.sessionStorage.isNew) {
    projectStore.setIsNew(Number(window.sessionStorage.isNew));
  }

  const stopTabTaskBadge = startAppTabTaskBadge();
  onUnmounted(stopTabTaskBadge);

  window.addEventListener('beforeunload', () => {
    stopTabTaskBadge();
    window.sessionStorage.businessPermission = JSON.stringify(permissionStore.businessPermission);
    window.sessionStorage.isNew = Number(projectStore.isNew);
  });

  useTitle();
</script>
<style lang="less">
  @import '/@/assets/iconfont/iconfont.css';
  @import './mainLess.less';

  .ant-modal-content {
    border-radius: @border-radius-large !important;
  }
  .ant-modal-header {
    border-radius: @border-radius-large @border-radius-large @no-border-radius @no-border-radius !important;
  }
  .ant-btn {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  .ant-input {
    color: @header-table-primary-color !important ;
    // border: 1px solid @border-color-primary !important;
  }
  .ant-select-item,
  .ant-select-selection-item {
    color: @header-table-primary-color !important ;
  }

  // .d-antd-input {
  //   margin-left: @border-radius-large;
  //   width: 355px !important;
  //   padding-left: 6px;
  //   // height: 30px;
  // }

  .d-antd-select {
    margin-left: @border-radius-large;
    width: 355px !important;
    padding-left: 6px;
    // height: 30px;
  }

  input:-moz-placeholder,
  textarea:-moz-placeholder {
    color: #b8bbce !important;
  }

  input:-ms-input-placeholder,
  textarea:-ms-input-placeholder {
    color: #b8bbce !important;
  }

  input::-webkit-input-placeholder,
  textarea::-webkit-input-placeholder {
    color: #b8bbce !important;
  }
</style>
